import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoutes from './App';
import { Provider } from 'react-redux'
import store from './redux-store/store'
import process from "process";
import { Buffer } from "buffer";

if (!window.process) window.process = process;
if (!window.Buffer) window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppRoutes />
  </Provider>
);
